// Sugalarm — small stat tile. Used by HistoryScreen and the AlertsScreen
// predictions summary. Big tabular-nums value with a tiny unit suffix.

import type { ReactNode } from "react";
import styles from "./StatCard.module.css";

interface Props {
  label: string;
  value: ReactNode;
  unit?: ReactNode;
  sub?: ReactNode;
  /** Cycle 169: frosted-glass fill — set only on the mobile frame so the
   *  aurora glows through. Kiosk/web omit it and render the solid card. */
  glass?: boolean;
}

export function StatCard({ label, value, unit, sub, glass = false }: Props) {
  return (
    <div className={`${styles.card} ${glass ? styles.glass : ""}`}>
      <span className={styles.label}>{label}</span>
      <div className={styles.value}>
        <span>{value}</span>
        {unit ? <span className={styles.unit}>{unit}</span> : null}
      </div>
      {sub ? <div className={styles.sub}>{sub}</div> : null}
    </div>
  );
}
